export const DEFAULT_ZOOM: number = 14;
export const PROJECT_PREVIEW_ZOOM: number = 17.5;
export const DEFAULT_MARKER_SCALE: number = 3;
export const DEFAULT_MARKER_FILL_OPACITY: number = 1;
export const DEFAULT_MARKER_STROKE_WEIGHT: number = 1;
export const DEFAULT_MAP_TYPE: string = 'satellite';
